import { useEffect, useState } from 'react';

/** True while the media query matches. Reads it synchronously so the first paint is already right. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    const sync = () => setMatches(list.matches);

    // Both signals: some embedded browsers resize the window without firing the media-query change.
    list.addEventListener('change', sync);
    window.addEventListener('resize', sync);
    sync();

    return () => {
      list.removeEventListener('change', sync);
      window.removeEventListener('resize', sync);
    };
  }, [query]);

  return matches;
}

/**
 * Barah Plus's `lg` breakpoint. Below it a 256px sidebar leaves no room for a data grid, so the menu
 * becomes a slide-in drawer.
 */
export const MOBILE_QUERY = '(max-width: 1023.98px)';
